<template>
  <div>
    <div v-if="documentToBeSigned">
      <div class="field" :class="{ 'is-horizontal': horizontal }">
        <div :class="{ 'field-label': horizontal }">
          <label class="label">{{ $t('signDocument.downloadAndSign') }}</label>
        </div>
        <div v-if="!disabled" :class="{ 'field-body': horizontal }">
          <div class="control image-input">
            <div class="placeholder">
              <img v-svg-inline class="inline-icon" :src="require('@/assets/icons/fa/far/download.svg')" style="margin-right: 10px;" />
              <a data-testid="document-to-be-signed" @click.prevent.stop="goToS3(documentToBeSigned, getFilename(documentToBeSigned))">{{ getFilename(documentToBeSigned) }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UploadControl
      :accept="accept"
      :horizontal="horizontal"
      :label="label"
      :get-signed-url="fileName => generateSignedUrl(fileName)"
      :verified="verified"
      :disabled="disabled"
      :message="message"
      :value="internal"
      @update:value="internal = $event"
    />
  </div>
</template>

<script>
import CaseService from '@/services/CaseService';
import UploadControl from '@/components/form/UploadControl.vue';
import UploadService from '@/services/UploadService';
import Utils from '../../../utils';
import FrontendService from '@/services/FrontendService';

export default {
  name: 'DynamicUploadSignedControl',
  components: {
    UploadControl
  },

  props: {
    accept: {
      type: String,
      default: '*/*'
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: () => 'File'
    },
    caseId: {
      type: String,
      default: null
    },
    globalDocumentToBeSigned: {
      type: String,
      default: null
    },
    localDocumentToBeSigned: {
      type: String,
      default: null
    },
    verified: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    }
  },

  computed: {
    documentToBeSigned() {
      if (this.localDocumentToBeSigned) return this.localDocumentToBeSigned;
      return this.globalDocumentToBeSigned;
    },
    internal: {
      get() {
        return this.value;
      },
      set(newValue) {
        // When the internal value changes, we $emit an event. Because this event is
        // named 'input', v-model will automatically update the parent value
        this.$emit('input', newValue);
      }
    }
  },

  methods: {
    // {{ field.url }}
    async generateSignedUrl(fileName) {
      if (this.caseId === 'new') {
        const response = await FrontendService.signClaimDataUpload(fileName);
        return response.data;
      } else {
        const response = await CaseService.signClaimdataUpload(this.caseId, fileName);
        return response.data;
      }
    },
    getFilename(url) {
      return Utils.getFilename(url);
    },
    async goToS3(url, filename) {
      const presigned = await UploadService.getSignedReadUrl(url, filename);
      window.open(presigned.data.url, '_blank');
    },
    isValid() {
      return this.internal;
    }
  }
};
</script>

<style lang="scss" scoped>
.image-input {
  display: block;
  width: 100%;
  height: 70px;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-size: contain;
  background-origin: content-box;
  padding: 10px;
}

.placeholder {
  padding: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: $primary;
}
</style>
